import { assignSafe } from '@summit/core';
import { MultiCompanyLogic } from '../payroll/multi-company-logic.enum';
import { PerDiemMethod } from '../payroll/per-diem/per-diem-method.enum';
import { PayrollBreakdown } from './payroll-breakdown.enum';
import { PayrollFormat } from './payroll-format.enum';
import { PendingImplementation } from './pending-implementation.enum';

export class TenantPayrollParameter {
  pendingImplementation: PendingImplementation;
  autoPaySettlementJumps: boolean;
  perDiemIncremental: boolean;
  integrateSpotMiles: boolean;
  allowGuaranteesToBeCorrectable: boolean;
  perDiemMethod: PerDiemMethod;
  hosHoursPerPerDiemDay: number;
  multiCompanyLogic: MultiCompanyLogic;

  format: PayrollFormat;
  templateName?: string;
  breakdown: PayrollBreakdown;
  includeProcessFileWithDraft: boolean;
  includeDriverTripReport: boolean;
  errorOnNoSpotWage: boolean;

  constructor(jsonData?: Partial<TenantPayrollParameter>) {
    if (jsonData) {
      assignSafe(this, jsonData);
    }
    this.format ??= PayrollFormat.Custom;
    this.breakdown ??= PayrollBreakdown.None;
    this.pendingImplementation ??= PendingImplementation.PrePay;
    this.perDiemMethod ??= PerDiemMethod.HOSBased;
    this.multiCompanyLogic ??= MultiCompanyLogic.PercentageOfMiles;
    this.autoPaySettlementJumps ??= true;
    this.includeProcessFileWithDraft ??= false;
    this.includeDriverTripReport ??= false;
    this.perDiemIncremental ??= false;
    this.integrateSpotMiles ??= false;
    this.errorOnNoSpotWage ??= false;
  }
}
